<template>
  <div>
    <search-list

      @searchData="findData"></search-list>
    <div class="page-wrapper">
    <table-list

      :columns="columns"
      :data="renterList"
      :current="current"
      :total="total"
      :loading="loading"
      @change-page="changPage"
    >
    </table-list>
    </div>
    <add-renter-modal @refresh="findData(searchData)" :isCompanyUpdate="isCompanyUpdate" :n="addKey" @show-img="showImg" :projectName="projectName" :stockNumber="stockNumber" :contractId="contractId" :projectFid="projectFid"  ></add-renter-modal>
    <read-or-update-modal :n="updateKey" :isRead="isRead" @show-img="showImg" :projectName="projectName" :stockNumber="stockNumber" :contractId="contractId" @refresh="findData(searchData)"></read-or-update-modal>
    <img-show :n="showImgKey" :src="imgSrc"></img-show>
  </div>

</template>

<script type="text/ecmascript-6">

  import {getList} from 'api/occupancy'
  import {formatDateTime} from '@/utils/format'
  import SearchList from './components/SearchList';
  import TableList from 'components/TableList/index';
  import AddRenterModal from './components/AddRenterModal'
  import ReadOrUpdateModal from './components/ReadOrUpdateRenterModal'
  import ImgShow from 'components/ImgShow/index'
  export default {
    name: 'renterlist',
    components: {
      SearchList,
      TableList,
      AddRenterModal,
      ReadOrUpdateModal,
      ImgShow

    },
    created() {
      this.findData(this.searchData)
    },
    data() {
      return {
        projectName:'',
        stockNumber:'',
        contractId:'',
        projectFid:'',
        addKey:0,
        isRead:false,
        isCompanyUpdate:false,
        updateKey:0,
        total: 0,
        current: 1,
        loading: true,
        imgSrc:'',
        showImgKey:0,
        searchData: {
          projectFid:'',
          contractState:'',
          subjectType:'',
          contractType:'',
          stockRentType:'',
          personDataStatus:'',
          conSignDateStart:'',
          conSignDateEnd:'',
          inputParam:'',
          page: 1,
          limit: 10
        },
        columns: [
          {
            type: 'index',
            width: 60,
            align: 'center'
          },
          {
            title:' '
          },
          {
            title: '项目',
            align: 'center',
            key: 'projectName',
            width: 160,
          },
          {
            title:' '
          },
          {
            title: '房间/床位号',
            align: 'center',
            key: 'stockNumber',
            width: 120,
          },
          {
            title:' '
          },
          {
            title: '出租方式',
            align: 'center',
            key: 'stockRentTypeCn',
            width: 100,
          },
          {
            title:' '
          },
          {
            title: '合同编号',
            align: 'center',
            key: 'contractCode',
            width: 160,

          },
          {
            title:' '
          },
          {
            title: '合同状态',
            align: 'center',
            key: 'contractStateCn',
            width: 100,
          },
          {
            title:' '
          },
          {
            title: '审核状态',
            align: 'center',
            key: 'auditStateCn',
            width: 100,
          },
          {
            title:' '
          },
          {
            title: '租客姓名',
            align: 'center',
            key: 'checkinName',
            width: 100,
          },
          {
            title:' '
          },
          {
            title: '租客手机号',
            align: 'center',
            key: 'phoneNum',
            width: 120,
          },
          {
            title:' '
          },
          {
            title: '签约时间',
            align: 'center',
            key: 'conSignDate',
            width: 120,
            render:(h,params) => {
              return h('span',formatDateTime(params.row.conSignDate,false))
            }
          },
          {
            title:' '
          },
          {
            title: '录入状态',
            align: 'center',
            key: 'enterStatusCn',
            width: 100,
          },
          {
            title: '是否存在合租人',
            align: 'center',
            key: 'hasSharer',
            width: 150,
            render:(h,params) => {
              return h('span', params.row.hasSharer ? '是' : '否')
            }
          },
          {
            title:' '
          },
          {
            title: '操作',
            align: 'center',
            key: 'action',
            width:160,
            fixed: 'right',
            render: (h, params) => {
              return h('div', [h('a',{
                directives:[
                  {
                    name:'p',
                    value:{
                      menu:'outhouse',
                      api:'checkinPersion/save'
                    }
                  }
                ],
                //当录入状态为未录入时展示
								style: {
                  marginRight: '5px',
                  display: params.row.enterStatus === 1 && (params.row.contractState ==='ycq' || params.row.contractState ==='yqy') ?'inline-block' :'none'
								},
								on:{
									click: () => {
                    this.isCompanyUpdate = false;
                    this.projectName = params.row.projectName;
                    this.projectFid = params.row.projectFid;
                    this.stockNumber = params.row.stockNumber;
                    this.contractId = params.row.contractFid;
                    this.addKey++
									}
								}
							},'添加'),h('a',{
                directives:[
                  {
                    name:'p',
                    value:{
                      menu:'outhouse',
                      api:'checkinPersion/save'
                    }
                  }
                ],
                //当录入状态为已录入时展示
								style: {
                  marginRight: '5px',
                  display: params.row.enterStatus === 2 && (params.row.contractState ==='ycq' || params.row.contractState ==='yqy'|| params.row.contractState ==='yqr') ?'inline-block' :'none'
								},
								on:{
									click: () => {
                    this.isRead = false;
                    this.projectName = params.row.projectName;
                    this.projectFid = params.row.projectFid;
                    this.stockNumber = params.row.stockNumber;
                    this.contractId = params.row.contractFid;
                    this.updateKey++
									}
								}
              },'修改'),
              h('a',{
                directives:[
                  {
                    name:'p',
                    value:{
                      menu:'outhouse',
                      api:'checkinPersion/detail'
                    }
                  }
                ],
                // 当录入状态为已录入时展示
								style: {
                  marginRight: '5px',
                  display: params.row.enterStatus === 2 ?'inline-block' :'none'
								},
								on:{
									click: () => {
                    this.isRead = true;
                    this.projectName = params.row.projectName;
                    this.projectFid = params.row.projectFid;
                    this.stockNumber = params.row.stockNumber;
                    this.contractId = params.row.contractFid;
                    this.updateKey++
									}
								}
              },'查看'),
              h('a',{
                directives:[
                  {
                    name:'p',
                    value:{
                      menu:'outhouse',
                      api:'checkinPersion/save'
                    }
                  }
                ],
                // 当录入状态为已录入，且合同类型为企业合同时展示 且合同状态非 已失效 已关闭 已到期 已退租
								style: {
                  marginRight: '5px',
                   display: (params.row.contractState ==='ycq' || params.row.contractState ==='yqy') && params.row.subjectType === 3 && params.row.enterStatus === 2 &&  (params.row.conStartDate < new Date().valueOf()) ?'inline-block' :'none'
								},
								on:{
									click: () => {
                    //
                    this.projectName = params.row.projectName;
                    this.projectFid = params.row.projectFid;
                    this.stockNumber = params.row.stockNumber;
                    this.contractId = params.row.contractFid;
                    this.isCompanyUpdate = true;
                    this.addKey++
									}
								}
							},'变更入住人')])
            }
          }
        ],
        renterList: []
      }
    },
    computed: {

    },
    methods: {
      changPage(n){
        this.current = n;
        this.searchData.page = n;
        this.getList(this.searchData)
      },
      findData(data) {
        this.searchData = data;
        this.current = 1;
        this.searchData.page = 1;
        this.loading = true;
        this.getList(this.searchData)
      },
      getList(data){
        getList(data).then( res => {
          this.renterList = res.data.rows;
          this.total = res.data.total;
          this.loading = false
        })
      },
      showImg(img) {
        this.imgSrc = img;
        this.showImgKey++
      }
    }
  }
</script>

<style lang="css" scoped>

</style>
